import { Component, Injectable } from '@angular/core';
import { CodeSnippet } from '../code-snippets/code-snippet.interface';



@Component({
    selector: 'read-adn-write-example-eq',
    template: '',
    standalone: false
})
export class EquivalenciesExample implements CodeSnippet{

    text: string = $localize`:@@script-editor.code-example.equivalent-variants:equivalent read/write variants`

    category: string = 'examples';

    data: any;

    part = false;

    insert(): string | Promise<string> {
        return `function main()

    -- this example might not run completely due to usage 
    -- restrictions on accessing datapoints.

    -- getting plant as variable
    local p = getplant()
    local v

    -- the following dp-read examples are all equivalent  
    v = getvalue('1!vNodeRED2PointStr')                   
    v = p.getvalue('1!vNodeRED2PointStr')                 
    v = p.Application.vNodeRED2PointStr
    v = p.Application['vNodeRED2PointStr']
    v = p.App.vNodeRED2PointStr                          
    v = p.A.vNodeRED2PointStr                             

    -- the following dp-write examples are all equivalent 
    setvalue('1!vNodeRED2PointStr', v)                    
    p.setvalue('1!vNodeRED2PointStr', v)                  
    p.Application.vNodeRED2PointStr = v
    p.Application['vNodeRED2PointStr'] = v
    p.App.vNodeRED2PointStr = v
    p.A.vNodeRED2PointStr = v

    -- datapoints containing special chars or starting with
    -- a number can be only read this way(s)
    v = getvalue('1!007vNodeRED2PointStr')                   
    v = p.getvalue('1!007vNodeRED2PointStr')                 
    v = p.Application['007vNodeRED2PointStr']
    v = p.App['007vNodeRED2PointStr']
    v = p.A['007vNodeRED2PointStr']                    

    -- datapoints containing special chars or starting with
    -- a number can be only written this way(s)
    setvalue('1!007vNodeRED2PointStr', v)                   
    p.setvalue('1!007vNodeRED2PointStr', v)                 
    p.Application['007vNodeRED2PointStr'] = v
    p.App['007vNodeRED2PointStr'] = v
    p.A['007vNodeRED2PointStr'] = v             

    show 'DONE'

end`
    }
}